import React from 'react';

import Icon from '../Icon/Icon';

const CrescendoBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g fillRule='nonzero' strokeWidth='2' fill='none' strokeLinecap='round'>
                <path
                    d='M29.67 11.662a5.956 5.956 0 0 1 1.443-.501c1.594-.343 3.125.085 4.047 1.177.839.964 1.216 2.42.86 3.383-.21.557-.554.937-1.036 1.19'
                    stroke='#00D1D2'
                    className='icon-accent-stroke'
                />
                <path
                    d='M7 27.09c3.745 0 7.302-5.065 10.438-9.557 1.498-2.15 2.949-4.158 4.26-5.449 2.574-2.532 4.727-4.11 8.05-4.826 3.557-.765 6.974.19 9.034 2.628 1.872 2.15 2.714 5.4 1.919 7.551-.468 1.243-1.236 2.093-2.312 2.657'
                    stroke='#272A33'
                />
                <path
                    d='M7 36.364c2.894 0 5.642-3.508 8.066-6.618 1.157-1.488 2.278-2.878 3.291-3.771 1.99-1.754 3.653-2.846 6.221-3.342 2.749-.53 5.39.132 6.98 1.82 1.447 1.488 2.098 3.738 1.484 5.227-.362.86-.956 1.45-1.787 1.84'
                    stroke='#272A33'
                />
                <path
                    d='M21.098 28.528c.156-.079 2.094-1.991 4.619-2.538 1.083-.235 2.13.058 2.76.803.571.657.829 1.65.585 2.306-.143.38-.377.64-.706.812'
                    stroke='#00D1D2'
                    className='icon-accent-stroke'
                />
                <path
                    d='M13.182 41c1.532 0 2.987-1.948 4.27-3.676.613-.827 1.206-1.6 1.742-2.096 1.053-.974 1.934-1.58 3.294-1.856 1.455-.294 2.853.073 3.695 1.01.766.828 1.111 2.078.785 2.905a1.864 1.864 0 0 1-.945 1.022'
                    stroke='#272A33'
                />
            </g>
        </Icon>
    );
};

export default CrescendoBlueIcon;
